<template>
    <div id="app">
        <div style="display: flex; width: 100%; height: 100vh">
            <leftPage v-if="showFooter"></leftPage>
            <div style="flex: 1">
                <topPage v-if="showFooter"></topPage>
                <router-view />
            </div>
        </div>

        <!-- <img alt="Vue logo" src="./assets/logo.png">
    <HelloWorld msg="Welcome to Your Vue.js App"/> -->
    </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
    name: 'App',
    data() {
        return {
            showFooter: true
        }
    },
    // components: {
    //     HelloWorld
    // }
    watch: {
        $route(to) {
            console.log(to.name, 123)

            console.log(!['HelloWorld'].includes(to.name))
            // 监听路由变化，根据需要调整showFooter的值
            this.showFooter =
                !['HelloWorld'].includes(to.name) &&
                !['homePage'].includes(to.name)
        }
    },
    created() {
        console.log(this.$route.name, 1111)
        if (this.$route.name === 'HelloWorld') {
            this.showFooter = false // 修改App.vue中的showFooter为false
        } else if (this.$route.name === 'homePage') {
            this.showFooter = false // 修改App.vue中的showFooter为false
        } else {
            this.showFooter = true
        }
        // this.checkMobile()
    }
}
</script>

<style>
@font-face {
    font-family: 'AlibabaPuHuiTi';
    src: url('http://96.9.231.213:8092/AlibabaSansTC-75.ttf') format('truetype');
    /* src: url('https://lzdbuck.oss-cn-beijing.aliyuncs.com/mianfeiziti.com.ttf')
        format('truetype'); */
    font-style: normal;
}

body {
    user-select: none; /* 标准语法 */
    -webkit-user-select: none; /* Safari */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* IE 10及以下 */
}
#app {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
html,
body {
    margin: 0;
    /* padding-bottom:2.96rem ; */
    /* padding-bottom:3.5rem ; */
    height: 100%;
    font-family: 'AlibabaPuHuiTi' !important;
}
/* 新增防止左右滑动的样式 */
html,
body {
    overflow-x: hidden; /* 禁止横向滚动 */
    width: 100%; /* 确保宽度不超出视口 */
    max-width: 100%; /* 确保最大宽度不超出视口 */
}

#app {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden; /* 禁止横向滚动 */
}

/* 主容器样式 */
#app > div {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden; /* 禁止横向滚动 */
}

/* 移动端适配 (max-width: 768px) */
@media screen and (max-width: 768px) {
    #app > div {
        flex-direction: column; /* 移动端改为垂直布局 */
    }

    leftPage {
        width: 100% !important; /* 侧边栏占满宽度 */
    }

    .content {
        width: 100% !important; /* 内容区占满宽度 */
    }
}
</style>
